export const toastsSelector = (state) => state.toastModel.toasts;
